import { createSlice } from '@reduxjs/toolkit';

export type DiToolingState = {
  showTrailEditToolbar?: boolean;
};

export const initialState: DiToolingState = {
  showTrailEditToolbar: false
};

export const diToolingSlice = createSlice({
  name: 'di-tooling',
  initialState,
  reducers: {
    openTrailEditToolbar: state => {
      state.showTrailEditToolbar = true;
    },
    closeTrailEditToolbar: state => {
      state.showTrailEditToolbar = false;
    }
  }
});

export const { openTrailEditToolbar, closeTrailEditToolbar } = diToolingSlice.actions;

export const diToolingReducer = diToolingSlice.reducer;
